const f = {
  color: {
    background: "#ffffffff",
    border: "#abb9c7ff",
    heading: "#556575ff",
    text: "#314351ff"
  }
};
export {
  f as popover
};
